import { EXTENDED_SERVER_ROWS_PER_PAGE_OPTIONS } from '../../../common/constants/paginationConstants';
import { PaginationTable } from '../../../common/components';

const ConsumptionsPagination = ({
  totalPages,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <PaginationTable
    totalPages={totalPages}
    totalCount={totalCount}
    page={page}
    rowsPerPage={rowsPerPage}
    rowsPerPageOptions={EXTENDED_SERVER_ROWS_PER_PAGE_OPTIONS}
    onPageChange={onPageChange}
    onRowsPerPageChange={onRowsPerPageChange}
  />
);

export default ConsumptionsPagination;
